'use client';

/**
 * Premium-features showcase. Hidden for now: it renders nothing, but stays
 * exported so the landing sections barrel keeps a stable shape.
 */
export function PremiumFeatures(): null {
  return null;
}
